import { Component } from '@angular/core';
import { SnackbarService } from '../../services/snackbar.service';

/**
 * CSV ratings upload (prototype).
 *
 * This component previously POSTed the selected file to a hardcoded endpoint:
 *
 *   https://6wxwejm79f.execute-api.us-west-2.amazonaws.com/TESTING/updateratingsdata
 *
 * That is a different AWS region, a stage literally named TESTING, and an API outside
 * the RAD SAM stack — it bypassed both environment.ts and environment.prod.ts, so a
 * production build shipped a call to a test backend. It also used
 * `aws-amplify/auth`, which cannot work here because `Amplify.configure()` is never
 * called anywhere in this application.
 *
 * The RAD backend exposes no ratings-CSV ingest route (only /ratingsInfo, which the
 * Manage Ratings screen uses), so there is nothing correct to point this at. The
 * cross-environment call has been removed and the action now reports that the feature
 * is unavailable instead of silently sending station data to a foreign test API.
 *
 * To enable this: add the ingest endpoint to rad-backend/template.yaml, then call it
 * here through ApiService using `environment.apiUrl` so DEV and PROD each hit their own
 * API Gateway.
 */
@Component({
  selector: 'app-upload-ratings',
  imports: [],
  templateUrl: './upload-ratings.component.html',
  styleUrl: './upload-ratings.component.css'
})
export class UploadRatingsComponent {

  csvFile: File | null = null;

  constructor(private snackbar: SnackbarService) {}

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0] ?? null;

    const csvTypes = [
      'text/csv',
      'application/csv',
      'text/comma-separated-values',
      'application/vnd.ms-excel',
    ];

    this.csvFile = file && csvTypes.includes(file.type) ? file : null;
  }

  upload(): void {
    if (!this.csvFile) {
      return;
    }

    this.snackbar.error(
      'Ratings CSV upload is not available yet. Use Manage Ratings to update ratings data.',
    );
  }
}
